function initProgressBars() {
  const bars = document.querySelectorAll(".product-progress-bar")
  const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches

  bars.forEach(bar => {
    const value = parseInt(bar.dataset.value)
    const max = parseInt(bar.getAttribute("aria-valuemax")) || 5
    const fill = bar.querySelector(".product-progress-bar__fill")

    if (!fill) return

    const ratio = value / max
    const targetWidth = `calc((100% - (2 * var(--tt-space-xs))) * ${ratio})`

    if (reduceMotion) {
      fill.style.width = targetWidth
      return
    }

    const observer = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (!entry.isIntersecting) return

          fill.style.width = targetWidth
          observer.unobserve(bar)
        })
      },
      { threshold: 0.3 }
    )

    observer.observe(bar)
  })
}

document.addEventListener("DOMContentLoaded", initProgressBars)
